var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalanxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 57,
    viewBox: "0 0 312 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.327973H20.0246C25.1293 0.327973 29.1408 1.76601 31.6973 4.37297C33.6784 6.39968 34.6977 8.87209 34.6977 11.9416V12.0677C34.6977 17.5508 31.6398 20.4857 28.3188 22.2433C33.5469 24.0682 37.1802 27.1377 37.1802 33.3355V33.4701C37.1802 41.6273 30.6123 46.0003 20.6657 46.0003H0V0.327973ZM26.8474 13.2451C26.8474 9.65418 24.0443 7.44246 19.0052 7.44246H7.71883V19.5775H18.4298C23.4688 19.5775 26.8474 17.5592 26.8474 13.3796V13.2451ZM7.71883 26.3556V38.8858H20.7315C26.0911 38.8858 29.3381 36.733 29.3381 32.6207V32.4861C29.3381 28.6346 26.3377 26.3556 20.1561 26.3556H7.71883Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2364 0H75.5031L95.1495 46.0003H86.8553L82.3259 34.9754H61.2163L56.6212 46.0003H48.5818L68.2364 0ZM79.4571 27.8609L71.7382 9.59531L64.0852 27.8609H79.4571Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.173 0.327973H117.015V38.6924H140.484V46.0003H109.173V0.327973Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.842 0H178.108L197.755 46.0003H189.461L184.931 34.9754H163.822L159.227 46.0003H151.187L170.842 0ZM182.062 27.8609L174.344 9.59531L166.691 27.8609H182.062Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.045 0.327973L242.958 31.9059V0.327973H250.677V46.0003H244.109L219.489 13.5058V46.0003H211.77V0.327973H219.045Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M311.359 0.327973L295.79 22.6554L312 46.0255H302.744L290.94 28.5925L274.162 53.3334H265.161L286.345 22.7815L270.833 0.327973H280.089L291.195 16.9116L302.358 0.327973H311.359Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M311.992 53.3418H283.089V57H311.992V53.3418Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanxLogo);
export default __webpack_public_path__ + "static/media/BALANX_logo.b482b19d54220badd5077dc62bc56edc.svg";
export { ForwardRef as ReactComponent };